import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../../catalog/config/component.config';

export namespace NCmsComponentHeroImage {
    export const ID = 'hero-image';

    export interface IData extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
        link: string;
        video_hide: boolean;
        ratio: string;
        ratioSource?: string;
        background_image: string;
        video_id: string;
        video_provider: 'youtube' | 'vimeo' | string;
        video_autoplay: boolean;
        video_background: boolean;
        width: string;
        blocks: IBlock[];
        isCollectionActive: boolean;
    }

    export interface IBlock {
        style: string;
        custom: boolean;
        components: NICmsContentComponent.IData[];
        top_position: number;
        left_position: number;
        lines: ILine[];
    }

    export interface ILine {
        type: 'button' | 'text' | 'countdown';
        align: 'left' | 'center' | 'right';
        form_size: string;
        button_class: 'button-1' | 'button-2' | 'button-inline';
        button_link: string;
        text: string;
        text_style: string;
        copyLink?: string;
        color: string;
        style: string;
        tag: string;
        end_date: Date;
    }
}
